<template>
    <drag-modal :visible="$store.state.dislog.partyPopUp" @cancel="close" title='修改代理人信息' width='780px'>
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
            <a-form-model-item label="诉讼代理模式：" prop="is_role_exact">
                <a-select v-model="form.is_role_exact" placeholder="请选择" class="nselect" @change='agCk($event, index)'>
                    <a-select-option v-for="i in agencyList" :key="i.id">{{ i.title }}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="诉讼立案代理人：" prop="is_full_pay">
                <a-input :maxLength="49" v-model="form.is_full_pay" placeholder="请填写诉讼立案代理人" />
            </a-form-model-item>
            <a-form-model-item label="开庭代理人：" prop="cause_is_complete">
                <a-input :maxLength="49" v-model="form.cause_is_complete" placeholder="请填写开庭代理人" />
            </a-form-model-item>
            <a-form-model-item label="执行代理模式：" prop="last_compensation_time">
                <a-select v-model="form.is_role_exact" placeholder="请选择" class="nselect" @change='agCk($event, index)'>
                    <a-select-option v-for="i in agencyList" :key="i.id">{{ i.title }}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="执行立案代理人：" prop="cause_is_complete">
                <a-input :maxLength="49" v-model="form.cause_is_complete" placeholder="请填写执行立案代理人" />
            </a-form-model-item>
            <a-form-model-item label="执行代理人：" prop="cause_is_complete">
                <a-input :maxLength="49" v-model="form.cause_is_complete" placeholder="请填写执行代理人" />
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
                <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
                    <a-button type="primary" style="width:148px;">
                        提交
                    </a-button>
                </a-popconfirm>
                <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;"
                    @click='close'>取消</a-button>
            </a-form-model-item>
        </a-form-model>
    </drag-modal>
</template>
<script>
import city from "@/assets/js/city.json"
import Validator from "@/assets/js/yz.js"
import { getAccuserAll } from "@/server/api"
import { mapGetters } from 'vuex'
import { citySort } from '@/assets/js/unit'

function isValidDate(date) {
    return date instanceof Date && !isNaN(date.getTime())
}
export default {
    name: 'partyPopUp',
    props: {
        agencyList: Array,
        i: Object
    },
    data() {
        return {
            Validator,
            audit: [],   //在修改中的字段
            options: citySort(city),
            accuserList: [],
            accuser: {},
            list: [
                {
                    id: 1,
                    title: '金融借款'
                }, {
                    id: 2,
                    title: '担保追偿'
                }, {
                    id: 3,
                    title: '融资租赁'
                }
            ],
            rules: {
                //    cause_is_complete: [{ required: true, message: '请选择是否案件完毕', trigger: 'change' }],
                is_full_pay: [{ required: true, message: '请选择是否代偿完毕', trigger: 'change' }],
                type: [{ required: true, trigger: 'change', message: '请选择被告类型' }],// 
                is_role_exact: [{ required: true, trigger: 'change', message: '请选择' }]
            },
            edit: false,
            form: {
                //    cause_is_complete: 0,
                last_compensation_time: "",
                is_full_pay: '',
                accuser_id: '',
                is_role_exact: '',
                car_type_id: '',
            }
        }
    },
    created() {
        this.init(this.$route.query.id)
        getAccuserAll().then((res) => {
            this.accuserList = res.list
        })
        this.form.is_role_exact = this.$store.state.cause.agent_model
    },
    computed: {
        ...mapGetters([
            'debInfo',
            'APIKEY'
        ])
    },
    methods: {
        close() {
            this.$store.dispatch('openkey', { key: 'partyPopUp', by: false })
        },
        isEdit(val) {
            let bool = this.audit.filter(ele => {
                return val.split(",").indexOf(ele.field) >= 0
            }).length > 0 ? true : false;
            return bool
        },
        confirm() {
            this.$refs.forms.validate(valid => {
                if (valid) {
                    let form = JSON.parse(JSON.stringify(this.form));
                    if (form.citys.length > 0) {
                        form.province = form.citys[0];
                        form.city = form.citys[1];
                        form.area = form.citys[2];
                        delete form.citys
                    }
                    if (form.dwell.length > 0) {
                        form.dwell_province = form.dwell[0];
                        form.dwell_city = form.dwell[1];
                        form.dwell_area = form.dwell[2];
                        delete form.dwell
                    }

                    let id = this.$route.query.id
                    if (id) {
                        form.id = id
                    }
                    this.$Ajax({
                        url: id ? 'debtor/edit' : 'debtor/add',
                        data: form,
                        success: (e) => {
                            this.$message.success({ content: id ? '修改成功' : '新增成功', key: 'updatable' });
                            this.reset()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // reset() {
        //     this.$refs.forms.resetFields();
        //     this.$router.back(-1)
        // },
        init(id) {
            this.edit = id ? true : false;
            if (id) {
                this.$Ajax({
                    url: 'debtor/info',
                    type: 'get',
                    data: { id: id },
                    success: (res) => {
                        let e = res.info;
                        this.audit = res.info.audit;
                        this.accuser = res.info.accuser || {}
                        this.form = {
                            accuser_id: e.accuser_id,
                            dwell: e.dwell_province ? [e.dwell_province, e.dwell_city, e.dwell_area] : [e.province, e.city, e.area],
                            last_compensation_time: isValidDate(new Date(e.last_compensation_time)) ? e.last_compensation_time : '',
                            is_role_exact: e.is_role_exact,
                            is_full_pay: e.is_full_pay,
                            type: e.type,
                            car_type_id: e.car_type_id
                        }
                    }
                })
            } else {
                this.rules.accuser_id = [{ required: true, trigger: 'change', message: '请选择原告' }]
            }
        }
    }
}
</script>
<style lang="less">
.newly .yellow {
    border: 1px solid #ff9800 !important;
    opacity: 1;
    color: #ccc;
    /* border: 0 none; */
    background: none;
    border-radius: 6px;
}
</style>
<style lang="less" scoped>
.newly {
    .form {
        width: 600px;
        margin: 0 auto;
    }

    background: #fff;
    padding: 60px 26px;
}
</style>